<template>
  <v-container fluid grid-list-md fill-height class="godawn-details">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <router-link to="/Dashboard">
            <v-btn icon dark >
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
          <v-toolbar-title >STORE LIST</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="godawn in godawnByBrand"
                  :key="godawn['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 18px 18px;">business</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="godawn['.key']+'G'">
                    <v-card-title primary-title class="headline">
                      <v-spacer />
                      {{godawn.godawnName}}
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <b class="subheading primary--text font-weight-light">{{godawn.godawnAddress}}</b>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <span>{{godawn.godawnPincode}}</span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-btn outline class="primary white--text" @click="openGodawnTransactions(godawn)">
                          <v-icon left class="primary--text">remove_red_eye</v-icon>
                            <a class="primary--text font-weight-light">View</a>
                        </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>  
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
         </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="viewTransaction" fullscreen hide-overlay>
      <v-card v-if="currentGodawn">
        <v-card-title class="primary white--text">
          <span class="headline">{{currentProductName}} - Transactions</span>
          <v-spacer />
          <v-btn icon dark @click.native="viewTransaction = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
        <v-data-table :items="currentGodawanProductTransaction" class="elevation" :headers="godawanTransactionHeaders">
        <template slot="items" slot-scope="props">
          <!-- <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td> -->
          <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
          <td class="red--text font-weight-bold">{{ props.item.quantity}}</td>
          <td class="primary--text font-weight-bold">{{  props.item.productName }}</td>
          <td class="green--text font-weight-bold">{{ props.item.type}}</td>
        </template>
        <template slot="no-data">no record found</template>
      </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewGodawn" fullscreen hide-overlay>
      <v-card v-if="currentGodawn">
        <v-card-title class="primary white--text">
          <span class="headline">{{currentGodawn.godawnName}} - Transactions</span>
          <v-spacer />
          <v-btn icon dark @click.native="viewGodawn = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="godawn-details">
             <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="product in currentGodawnProducts"
                  :key="product['productName']+'a'"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 18px 18px;">shopping_basket</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="product['productName']+'G'">
                    <v-card-title primary-title class="headline">
                      <v-spacer />
                      {{product.productName}}
                    </v-card-title>
                    <v-card-actions class="title font-weight-bold" v-if="product.totalQuantity <= 0">
                      <v-spacer></v-spacer>
                      <span>Quantity: &nbsp; 
                        <b class="font-weight-bold title red--text">
                          {{product.totalQuantity}}
                        </b>
                      </span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions class="title font-weight-bold" v-if="product.totalQuantity > 0">
                      <v-spacer></v-spacer>
                      <span>Quantity: &nbsp; 
                        <b class="font-weight-bold title green--text">
                          {{product.totalQuantity}}
                        </b>
                      </span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn outline class="primary white--text" @click="openGodawnProductList(product)">
                      <v-icon left class="primary--text">remove_red_eye</v-icon>
                      <a class="primary--text font-weight-light">View</a>
                      </v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions> 
                  </v-card>
                </v-flex>
              </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      viewTransaction : false,
      viewGodawn : false,
      currentGodawn : null,
      currentGodawanTransaction : [],
      currentGodawanProductTransaction : [],
      currentGodawnProducts:[],
      currentProductName : '',
      godawanTransactionHeaders: [
        { text: "Date", value: "date", sortable: true, class:"primary--text font-weight-bold" },
        { text: "Quantity", value: "quantity", sortable: true, class:"primary--text font-weight-bold" },
        { text: "Product", value: "name", sortable: true, class:"primary--text font-weight-bold" },
        { text: "Type", value: "type", sortable: true, class:"primary--text font-weight-bold" },
      ],
    };
  },
  created() {
    this.$bindAsObject("productDetail", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    godawnByBrand() {
      return this.godawns
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand 
          );
        });
    },
  },
  methods: {
   openGodawnTransactions(godawn){
     this.currentGodawn = godawn;
     this.currentGodawanTransaction = this.godawnTrans.filter(item => item['brand'] == this.selectedBrand && item['godawn'] == godawn['.key'] );
     this.currentGodawanTransaction.map((item,index)=>{
       this.currentGodawanTransaction[index]['productName'] = this.productDetail[item.product].name;
       this.currentGodawanTransaction[index]['type'] = 'Transfer';
       this.currentGodawanTransaction[index]['totalQuantity'] = 0;
     });

     // let invoices = this.invoices.filter(item => (item['brand'] == this.selectedBrand && item['godawnBy'] == godawn['.key'] && (item.date >= this.finYear.start) && (item.date <= this.finYear.end)));
     let invoices = this.invoices.filter(item => (item['brand'] == this.selectedBrand && (item.date >= this.finYear.start) &&  (item.deleted != true) &&  (item.date <= this.finYear.end)));
     invoices.map((invoice,index)=>{ 
       invoice.items && invoice.items.map((item)=>{
        //  let obj = {}
        //  obj['.key'] = invoice['.key'];
        //  obj['date'] = invoice['date'];
        //  obj['quantity'] = item['quantity'];
        //  obj['productName'] = item['productName'];
        //  obj['totalQuantity'] = 0;
        //  obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase' ;
        //  this.currentGodawanTransaction.push(obj);

         if(item['godawnBy'] == godawn['.key']) {
            let obj = {}
            obj['.key'] = invoice['.key'];
            obj['date'] = invoice['date'];
            obj['quantity'] = item['quantity'];
            obj['productName'] = item['productName'];
            obj['totalQuantity'] = 0;
            obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase' ; 
            this.currentGodawanTransaction.push(obj);
         } 
       })
     })
    
    let finalResult = [];

     this.currentGodawanTransaction.map((item)=>{
       let index =  _.findIndex(finalResult,{productName : item.productName})
       if(index > -1) {
         finalResult[index].totalQuantity += (item.type == 'Sale' ? (-item['quantity']) : (item['quantity']))
       } else {
         item.totalQuantity = item.quantity;
         finalResult.push(item)
       }
     })
     this.currentGodawnProducts = finalResult;
     this.viewGodawn = true;
   },
   openGodawnProductList(product){
      this.currentProductName = product.productName;
      this.viewTransaction = true;
      this.currentGodawanProductTransaction =  _.filter(this.currentGodawanTransaction, (p)=> {
        return p.productName== product.productName; 
      })
   },
   renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  }
};
</script>

<style scoped>
.card__text.number {
  font-size: xx-large;
  font-weight: bolder;
}

.godawn-details .sec1-card {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #15155d !important;
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
}

.godawn-details .headline {
  font-weight: bold;
  margin-left: 70px;
}

.godawn-details .v-card__title--primary {
  padding: 5px;
}

.godawn-details .icon-card {
  width: 60px;
  height: 60px;
  z-index: 2;
  top: 30px;
  background: #15155d;
  left: 10px;
}

.godawn-details .icon-card i {
  padding: 12px;
  color: white;
}

.godawn-details .sec3-card {
  position: relative;
  bottom: 7px;
  margin-bottom: 10px;
  font-size: 20px;
  text-align: left;
  padding-left: 9px;
  color: #15155d;
  font-weight: bold;
}
/* .dashboardHead th.column.text-xs-left {
  text-align: center !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/Godawn/godawn.vue